<template>
  <div
    :class="[
      'inviteStatusContiner',
      { autoAlign: autoAlign, largePaddingTop: showPhoneNumber }
    ]"
  >
    <div
      v-for="(item, index) in inviteList"
      :key="item.id"
      :class="['inviteSlot', size, gapSize]"
      :style="avatarStyle(item.avatar)"
      @click="handleClick(index, item.isInvited ? 'avatar' : 'add')"
    >
      <div v-if="index === showPhoneNumberIndex" class="floatPhoneNumber">
        {{ item.phoneNumber }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      showPhoneNumberIndex: -1
    };
  },
  props: {
    size: {
      type: String,
      default: 'normal',
      validator: function(value) {
        return ['normal', 'large'].indexOf(value) !== -1;
      }
    },
    total: {
      type: Number,
      require: true
    },
    current: {
      type: Number,
      require: true
    },
    defaultAvatarImage: {
      type: String,
      require: true
    },
    // 空态头像
    emptyAvatarImage: {
      type: String,
      require: true
    },
    // 默认居中对齐
    autoAlign: {
      type: Boolean,
      default: true
    },
    inviteeInfos: {
      type: Array,
      default: function() {
        return [];
      }
    },
    showPhoneNumber: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    handleClick(index, type) {
      this.$emit('click', type);
      if (type === 'avatar' && this.showPhoneNumber) {
        this.showPhoneNumberIndex = index;
        clearTimeout(this.floatPhoneNumberTimer);
        this.floatPhoneNumberTimer = setTimeout(() => {
          this.showPhoneNumberIndex = -1;
        }, 3000);
      }
    },
    avatarStyle(avatar) {
      return {
        background: `center / cover url("${avatar}") no-repeat`
      };
    }
  },
  computed: {
    gapSize() {
      return this.inviteList.length > 3 ? 'smallGap' : 'largeGap';
    },
    defaultAvatarStyle() {
      return {
        background: `center / cover url("${this.defaultAvatarImage}") no-repeat`
      };
    },
    emptyAvatarStyle() {
      return {
        background: `center / cover url("${this.emptyAvatarImage}") no-repeat`
      };
    },
    inviteList() {
      const list = [];
      const inviteeInfos = this.inviteeInfos;
      for (let i = 0; i < this.total; i += 1) {
        if (i < this.current) {
          const inviteeInfo = inviteeInfos[i] || {};
          list.push({
            isInvited: true,
            avatar: inviteeInfo.icon || this.defaultAvatarImage,
            phoneNumber: inviteeInfo.phoneNumber
          });
          continue;
        }
        list.push({
          avatar: this.emptyAvatarImage
        });
      }
      return list;
    }
  }
};
</script>

<style lang="less" scoped>
.inviteStatusContiner {
  overflow-x: auto;
  display: flex;
  justify-content: left;
  padding: 20px 15px 0 15px;

  &.largePaddingTop {
    padding-top: 30px;
  }

  &.autoAlign {
    margin: auto;
  }

  .inviteSlot {
    position: relative;
    .floatPhoneNumber {
      position: absolute;
      width: 140px;
      height: 42px;
      font-size: 20px;
      color: #333333;
      background: center / contain url('../assets/images/float-tag.png')
        no-repeat;
      border-radius: 17px;
      padding: 2px 5px 0;
      text-align: center;
      left: 50%;
      top: -30px;
      transform: translateX(-50%);
    }

    &.normal {
      margin: 0 15px;
      width: 74px;
      height: 74px;
    }

    &.large {
      width: 94px;
      height: 94px;

      &.smallGap {
        margin: 0 20px;
      }

      &.largeGap {
        margin: 0 27px;
      }
    }
  }
}
</style>
